import { render, staticRenderFns } from "./ExclusivesTable.vue?vue&type=template&id=fd8fa726&scoped=true&"
import script from "./ExclusivesTable.vue?vue&type=script&lang=js&"
export * from "./ExclusivesTable.vue?vue&type=script&lang=js&"
import style0 from "./ExclusivesTable.vue?vue&type=style&index=0&id=fd8fa726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8fa726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDataTable,VSpacer})
